import { createListenerMiddleware } from '@reduxjs/toolkit';
import { PRODUCT_LISTING_SET_URL_COUNT } from '../constants';
import { AnyAction } from 'redux';

export const productListingListener = createListenerMiddleware();

productListingListener.startListening({
  type: PRODUCT_LISTING_SET_URL_COUNT,
  effect: (action: AnyAction) => {
    setUrlCount(action.payload.count);
  },
});

const setUrlCount = (count: number) => {
  const query = new URLSearchParams(window.location.search);
  if (count > 0) {
    query.set('count', count.toString());
  } else {
    query.delete('count');
  }
  const queryStr = query.toString();
  const url =
    window.location.href.replace(window.location.search, '') +
    (queryStr.length > 0 ? `?${queryStr}` : '');
  window.history.replaceState('setUrlCount', '', url);
};
